import { v4 as uuidv4 } from 'uuid';

const usePagesUserId = () => {
    const faqbotUserIdKey = 'faqbot-pages-user-id';
    const returningUserId = window.localStorage.getItem(faqbotUserIdKey);
    const userId = returningUserId || uuidv4();
    if (!returningUserId) {
        window.localStorage.setItem(faqbotUserIdKey, userId);
    }

    window.localStorage.setItem('ChatBotUserId', userId);

    return userId;
};

export default usePagesUserId;
